import React, { useEffect } from "react";
import { Navigate, Routes, Route } from "react-router-dom";

import Sidebar from "./components/Sidebar";
import VsiContent from "./components/VsiContent";
import Login from "./pages/Login";

import { VsiApp } from "./styled/App.styled";

import "ag-grid-enterprise/styles/ag-grid.css";
import "ag-grid-enterprise/styles/ag-theme-alpine.css";
import "react-toggle/style.css";
import "./App.css";

import MobileNav from "./components/MobileNav";
import LoadingFullScreen from "./components/LoadingFullScreen";

import { useVsiAppContext } from "./stores/VsiApp";
import themeStyles from "./utils/themeStyles";
import { clearOldReports } from "./utils/idb";
import { indexedDbMaxAgeMs } from "./utils/utils";

// clearing old cache on app startup
clearOldReports(indexedDbMaxAgeMs).then(console.log).catch(console.error);

function App() {

  const { isVsiAppLoading, isVsiUserAuthenticated, theme } = useVsiAppContext();

  useEffect(() => {
    // not ideal but it gets around the reactstrap normalizer.
    // this is just for the whitespace and we shouldn't see a lot of yucky around this
    document.body.style.backgroundColor = themeStyles[theme].bgColor;
  }, [theme]);

  if (isVsiAppLoading && !isVsiUserAuthenticated)
    return <LoadingFullScreen />;
  else if (
    !isVsiAppLoading &&
    isVsiUserAuthenticated
  ) {
    return (
      <VsiApp>
        <Sidebar />
        <VsiContent />
        <MobileNav />
      </VsiApp>
    );
  } else {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    );
  }
}

export default App;

